import { useState } from 'react';

import { Grid } from '@mui/material';
import { DateRangePicker, LocalizationProvider, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { StoreAutoComplete } from 'components/autocompletes';
import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { useApplicationContext } from 'context/ApplicationContext';
import { FilterValuesProps, useFilter } from 'hooks/useFilter';

export function FormFilterNota() {
    const { formattedStore } = useApplicationContext();
    const { handleFilterReset } = useFilter();

    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        property: 'cdLoja',
        operator: 'in',
        value: [],
        idProperty: 'cdLoja',
        required: 'Loja é obrigatória',
    });

    const [filterInterval, setFilterInterval] = useState<FilterValuesProps>({
        property: 'dhMovimentacao',
        operator: 'bt',
        startDate: null,
        endDate: null,
        required: 'Intervalo de movimentação é obrigatório',
    });

    const [filterNumeroNota, setFilterNumeroNota] = useState<FilterValuesProps>({
        property: 'nrNota',
        operator: 'like',
        value: '',
    });

    const filters = [
        { value: filterLoja, setter: setFilterLoja },
        { value: filterInterval, setter: setFilterInterval },
        { value: filterNumeroNota, setter: setFilterNumeroNota },
    ];

    /**
     * Reseta ps filtros e define a loja padrão.
     */
    const resetFilter = () => {
        handleFilterReset({ filters });

        setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value: formattedStore }));
    };

    return (
        <Filter preventQueryParamsEmptyStart reset={resetFilter} filters={filters}>
            <Grid sx={{ flex: 2 }}>
                <StoreAutoComplete
                    value={filterLoja.value}
                    multiple={true}
                    onChange={(e, value) => setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ width: '100%', flex: 2 }}>
                <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns} localeText={{ start: 'Data Início', end: 'Data Fim' }}>
                    <DateRangePicker
                        value={[filterInterval.startDate ?? null, filterInterval.endDate ?? null]}
                        onChange={([startDate, endDate]) => {
                            setFilterInterval((oldState: FilterValuesProps) => ({
                                ...oldState,
                                startDate,
                                endDate,
                            }));
                        }}
                        slots={{ field: MultiInputDateRangeField }}
                        slotProps={{
                            field: { dateSeparator: 'até' },
                            textField: { autoComplete: 'off' },
                        }}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="N° da nota"
                    value={filterNumeroNota.value}
                    onChange={(e) => setFilterNumeroNota((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
